module.exports = __webpack_public_path__ + "img/thumb_11.c1bcd7cf.jpg";